import type { App } from 'vue';
import type { ArcoIconOptions } from '../../_utils/types';
import _IconNoNotesColor from './icon-no-notes-color.vue';

const IconNoNotesColor = Object.assign(_IconNoNotesColor, {
  install: (app: App, options?: ArcoIconOptions) => {
    const iconPrefix = options?.iconPrefix ?? '';
    app.component(iconPrefix + _IconNoNotesColor.name, _IconNoNotesColor);
  }
});

export default IconNoNotesColor;
